import { Title, Subtitle, SuccessGif, SuccessWrapper } from '~components'
import { usePreventBrowserBack, useNavigate } from '~hooks'

const Success = () => {
  const navigate = useNavigate()

  usePreventBrowserBack()

  setTimeout(() => {
    navigate('/entrar', { state: { previousPath: '/recuperar-senha-motorista/sucesso' }})
  }, 3500)

  return (
    <SuccessWrapper role="region">
      <SuccessGif />
      <Title>Sucesso!</Title>
      <Subtitle>
        A sua senha já foi alterada. Entre para ver os fretes disponíveis para você.
      </Subtitle>
    </SuccessWrapper>
  )
}

export default Success
